import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VoucherDownloadBtnComponent } from 'src/app/components/sale/order/voucher/voucher-download-btn/voucher-download-btn.component';
import { PartialModule } from '../partial/partial.module';
import { VoucherEmailSendComponent } from '../../components/sale/order/voucher/voucher-email-send/voucher-email-send.component';
import { FormModule } from '../form/form.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VoucherEmailModalComponent } from '../../components/sale/order/voucher/voucher-email-modal/voucher-email-modal.component';
import { PaymentLinkEmailSendComponent } from 'src/app/components/sale/payment/btn/payment-link-email-send/payment-link-email-send.component';
import { PaymentLinkOpenSendComponent } from '../../components/sale/payment/btn/payment-link-open-send/payment-link-open-send.component';
import { OrderItemComponent } from 'src/app/components/sale/order/order-item/order-item.component';
import { PaymentLinkEmailModalComponent } from 'src/app/components/sale/payment/modal/payment-link-email-modal/payment-link-email-modal.component';

@NgModule({
    declarations: [
        VoucherDownloadBtnComponent,
        VoucherEmailSendComponent,
        VoucherEmailModalComponent,
        PaymentLinkEmailSendComponent,
        PaymentLinkOpenSendComponent,
        PaymentLinkEmailModalComponent,
        OrderItemComponent
    ],
    exports: [
        VoucherDownloadBtnComponent,
        VoucherEmailSendComponent,
        VoucherEmailModalComponent,
        PaymentLinkEmailSendComponent,
        PaymentLinkOpenSendComponent,
        OrderItemComponent,
        PaymentLinkEmailModalComponent
    ],
    imports: [
        CommonModule,
        PartialModule,
        FormModule,
        FormsModule,
        ReactiveFormsModule
    ]
})
export class OrderModule { }
